module.exports = __webpack_public_path__ + "img/Manuel_Ojeda.2ad94486.jpg";